import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
  },
  toggle: {
    height: 64,
    width: 300,
    minWidth: 260,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 16,
    backgroundColor: theme.palette.background.default,

    fontSize: 18,
    fontWeight: 700,
    fontFamily: 'Poppins',
    textTransform: 'uppercase',
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
  },
  toggleSelected: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
  },
  item: {
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
  },
  button: {
    backgroundColor: theme.palette.background.default,
    borderRadius: 32,
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    // padding: 8,
  },
  label: {
    fontSize: 18,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
}));
